package navigation.home.edititinerary

import cafe.adriel.voyager.core.model.StateScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import com.essntl.core.axus.domain.AxusClient
import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.features.area.domain.repository.AreaRepository
import com.essntl.features.category.domain.repository.CategoryRepository
import com.essntl.features.client.domain.repository.ClientRepository
import com.essntl.features.file.domain.repository.FileRepository
import com.essntl.features.itinerary.domain.repository.ItineraryRepository
import com.essntl.features.itinerary.domain.use_case.UpdateItineraryServiceUseCase
import com.essntl.features.itinerary.ui.edit_itinerary.EditItineraryEvent
import com.essntl.features.itinerary.ui.edit_itinerary.EditItineraryState
import com.essntl.features.itinerary.ui.edit_itinerary.EditItineraryViewModel
import com.essntl.features.message.domain.repository.MessageRepository
import com.essntl.features.message.domain.useCase.SendItineraryMessageUseCase
import com.essntl.features.profile.domain.use_case.GetCurrentUserUseCase
import com.essntl.features.proposal.domain.repository.ProposalRepository
import com.essntl.features.task.domain.repository.TaskRepository
import com.essntl.features.task.domain.use_case.AddTaskUseCase
import com.essntl.features.task.domain.use_case.DeleteTaskUseCase
import com.essntl.features.task.domain.use_case.UpdateTaskUseCase
import com.essntl.toastmanager.ToastManager

class EditItineraryScreenModel(
    itineraryRepository: ItineraryRepository,
    proposalRepository: ProposalRepository,
    fileRepository: FileRepository,
    clientRepository: ClientRepository,
    categoryRepository: CategoryRepository,
    areaRepository: AreaRepository,
    taskRepository: TaskRepository,
    messageRepository: MessageRepository,
    updateItineraryServiceUseCase: UpdateItineraryServiceUseCase,
    addTaskUseCase: AddTaskUseCase,
    updateTaskUseCase: UpdateTaskUseCase,
    deleteTaskUseCase: DeleteTaskUseCase,
    getCurrentUserUseCase: GetCurrentUserUseCase,
    sendItineraryMessageUseCase: SendItineraryMessageUseCase,
    axusClient: AxusClient,
    toastManager: ToastManager,
    loadingManager: LoadingManager,
) : StateScreenModel<EditItineraryState>(EditItineraryState()) {
    private val vm =
        EditItineraryViewModel(
            itineraryRepository = itineraryRepository,
            proposalRepository = proposalRepository,
            fileRepository = fileRepository,
            clientRepository = clientRepository,
            categoryRepository = categoryRepository,
            areaRepository = areaRepository,
            taskRepository = taskRepository,
            messageRepository = messageRepository,
            updateItineraryServiceUseCase = updateItineraryServiceUseCase,
            addTaskUseCase = addTaskUseCase,
            updateTaskUseCase = updateTaskUseCase,
            deleteTaskUseCase = deleteTaskUseCase,
            getCurrentUserUseCase = getCurrentUserUseCase,
            sendItineraryMessageUseCase = sendItineraryMessageUseCase,
            axusClient = axusClient,
            toastManager = toastManager,
            scope = screenModelScope,
            state = mutableState,
            loadingManager = loadingManager,
        )

    fun onEvent(event: EditItineraryEvent) = vm.onEvent(event)
}
